<template>
  <pages-wrapper>
    <div class="delivery">
      <h1 class="delivery-title">
        Доставка в городе
        <span @click="changeCity">
          {{ cityName || USER_CITY.name }}
        </span>
      </h1>

      <ui-tabs
        class="delivery-tabs"
        v-model="tab"
        :items="tabs"
      />
    </div>
  </pages-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
/* Components */
import PagesWrapper from '../../components/info-pages/pages-wrapper';
import pageMetaMixin from '@/mixins/page-meta-mixin';

export default {
  name: 'delivery',

  metaInfo() {
    return this.getPageMeta({ pageTitle: 'Доставка' });
  },

  components: {
    PagesWrapper
  },

  mixins: [pageMetaMixin],

  data() {
    return {
      tab: 'parcel',
      cityName: '',
    }
  },

  computed: {
    ...mapGetters({
      USER_CITY: 'user/city',
      GET_FRAGMENT: 'staticPages/fragments'
    }),

    tabs() {
      return [
        {
          key: 'parcel',
          name: 'Курьерская доставка',
          content: this.GET_FRAGMENT('delivery_info_page'),
          contentClass: 'delivery-page-content',
        },
        {
          key: 'pickup',
          name: 'Самовывоз из магазина',
          content: this.GET_FRAGMENT('delivery_info_page_pickup'),
          contentClass: 'delivery-page-content',
        },
        {
          key: 'pvz',
          name: 'Постаматы и ПВЗ',
          content: this.GET_FRAGMENT('delivery_info_page_pvz'),
          contentClass: 'delivery-page-content',
        }
      ].filter(t => t.content); // выводим только табы для которых есть контент
    }
  },

  methods: {
    ...mapActions({
      LOAD_FRAGMENT: 'staticPages/loadStaticFragments'
    }),

    changeCity() {
      this.$city.changeCity().then(({ name, id }) => {
        this.cityName = name;
        this.tab = 'parcel';
        return this.updatePageContent(id);
      }).catch(() => {});
    },

    updatePageContent(cityId) {
      return Promise.all([
        this.LOAD_FRAGMENT({slotName: 'delivery_info_page', cityId}),
        this.LOAD_FRAGMENT({slotName: 'delivery_info_page_pickup', cityId}),
        this.LOAD_FRAGMENT({slotName: 'delivery_info_page_pvz', cityId}),
      ])
    }
  },

  serverPrefetch() {
    return Promise.all([
      this.LOAD_FRAGMENT({slotName: 'delivery_info_page'}),
      this.LOAD_FRAGMENT({slotName: 'delivery_info_page_pickup'}),
      this.LOAD_FRAGMENT({slotName: 'delivery_info_page_pvz'}),
    ])
  }
};
</script>

<style lang="scss">
.delivery {

  &-tabs {
    margin-top: 18px;
  }

  &-title {
    span {
      color: $blue;
      cursor: pointer;
    }
  }

  .ui-tabs-wrapper > ul {
    padding: 0 16px;

    & > li {
      margin-top: 0;
      font-size: 14px;
      line-height: 20px;
    }

    & > li::before,
    & > li::after {
      content: none;
    }
  }
}

@include breakpoint("desktop") {
  .delivery {
    &-tabs {
      margin-top: 32px;
    }

    .ui-tabs-wrapper > ul {
      padding: 0;

      & > li {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
}
</style>
